(() => {
  "use strict";
  const ROOT = window.Shopify?.routes?.root || "/";
  // Scoped to the four alcohol-consent inputs; no checkout or other forms.
  if (!document.getElementById("alcohol-consent-field-visibility")) {
    const style = document.createElement("style");
    style.id = "alcohol-consent-field-visibility";
    const fields = ["#AlcoholConsentName", "#AlcoholConsentEmail",
      "#AlcoholConsentPageName", "#AlcoholConsentPageEmail"];
    const selector = fields.join(",");
    const focused = fields.map(field => `${field}:focus`).join(",");
    const placeholders = fields.map(field => `${field}::placeholder`).join(",");
    style.textContent = `
      ${selector} {
        display: block;
        width: 100%;
        box-sizing: border-box;
        min-height: 44px;
        padding: 12px !important;
        border: 1px solid #767676 !important;
        border-radius: 4px;
        background-color: #ffffff !important;
        color: #1a1a1a !important;
        font-size: 16px;
        line-height: 1.4;
        opacity: 1 !important;
      }
      ${focused} {
        border-color: #1a1a1a !important;
        outline: 2px solid #1a1a1a !important;
        outline-offset: 2px;
      }
      ${placeholders} { color: #666666; opacity: 1; }
    `;
    document.head.appendChild(style);
  }
  const raw = (document.documentElement.lang || window.Shopify?.locale || "en").toLowerCase();
  const language = raw === "es" || raw.startsWith("es-") ? "es"
    : raw === "pt" || raw.startsWith("pt-") ? "pt-BR" : "en";
  const translations = {
    en: { prefix: "I agree to the ", label: "Alcoholic beverages shipping policy", alert: "Please accept the alcoholic beverages shipping policy to continue." },
    es: { prefix: "Acepto la ", label: "política de envío de bebidas alcohólicas", alert: "Acepta la política de envío de bebidas alcohólicas para continuar." },
    "pt-BR": { prefix: "Concordo com a ", label: "política de envio de bebidas alcoólicas", alert: "Aceite a política de envio de bebidas alcoólicas para continuar." }
  };
  const expectedUrl = new URL(`${ROOT}pages/rule-for-shipping-of-alcoholic-beverages`, location.origin).href;

  function adapt(container) {
    if (!container) return false;
    const nodes = Array.from(container.querySelectorAll('[id="tncText"]'));
    let matched = false;
    const text = translations[language];
    for (const box of nodes) {
      const link = box.querySelector('a[data-anchorlinkid="1"]');
      if (!link) continue;
      let current;
      try { current = new URL(link.href); } catch { continue; }
      if (!current.pathname.endsWith("/pages/rule-for-shipping-of-alcoholic-beverages")) continue;
      if (link.textContent !== text.label) link.textContent = text.label;
      if (link.href !== expectedUrl) link.href = expectedUrl;
      if (link.rel !== "noopener noreferrer") link.rel = "noopener noreferrer";
      if (box.textContent !== text.prefix + text.label) {
        // Preserve the existing anchor and checkbox. Only replace label text nodes.
        box.replaceChildren(document.createTextNode(text.prefix), link);
      }
      matched = true;
    }
    // Restrict the app alert translation to its known T&C containers.
    container.querySelectorAll('.gm_tncContainer .sweetAlertText').forEach(element => {
      if (element.textContent !== text.alert) element.textContent = text.alert;
    });
    return matched;
  }

  window.AlcoholConsentPolicyUI = Object.freeze({
    ensure(container, expectedLanguage) {
      if (expectedLanguage !== language) return false;
      if (!adapt(container)) return false;
      const boxes = Array.from(container.querySelectorAll('[id="tncText"]'));
      return boxes.some(box => {
        const link = box.querySelector('a[data-anchorlinkid="1"]');
        return link?.href === expectedUrl &&
          box.textContent === translations[language].prefix + translations[language].label;
      });
    }
  });

  let scheduled = false;
  function refresh() {
    scheduled = false;
    document.querySelectorAll('cart-drawer, #main-cart-footer').forEach(adapt);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }
  const observer = new MutationObserver(schedule);
  observer.observe(document.documentElement, {
    subtree: true, childList: true, characterData: true,
    attributes: true, attributeFilter: ["href", "lang"]
  });
  schedule();
})();

(() => {
  "use strict";

  const API_URL = "https://brazilian-consent-api.brazilianshop.workers.dev/consent";
  const ROOT = window.Shopify?.routes?.root || "/";
  const TERMS_VERSION = "1.2";
  const rawLocale = (document.documentElement.lang || window.Shopify?.locale || "en").toLowerCase();
  const LANGUAGE = rawLocale === "es" || rawLocale.startsWith("es-") ? "es"
    : rawLocale === "pt" || rawLocale.startsWith("pt-") ? "pt-BR" : "en";
  const POLICY_HASHES = {
    en: "01f4b67d20f3599faa460f71c0f6856ce457ab0ed01d9488d876599659feb19e",
    es: "b9ae3b333ff2e0f929159293977429d7dbf763b34b725ca08a759569e6c3b12f",
    "pt-BR": "e666cd03ae92f9eb252ada4265a7482ceecd18eb82be767834cb31c7d667f99a"
  };
  const MESSAGES = {
    "Please accept the alcoholic beverages shipping policy.": {
      es: "Acepta la política de envío de bebidas alcohólicas.",
      "pt-BR": "Aceite a política de envio de bebidas alcoólicas."
    },
    "Please enter your full name.": {
      es: "Introduce tu nombre completo.", "pt-BR": "Preencha seu nome completo."
    },
    "Please enter a valid email address.": {
      es: "Introduce una dirección de correo electrónico válida.",
      "pt-BR": "Preencha um endereço de e-mail válido."
    },
    "Please complete the security verification if prompted.": {
      es: "Completa la verificación de seguridad si se solicita.",
      "pt-BR": "Conclua a verificação de segurança, se solicitada."
    },
    "Recording your acceptance. Please wait.": {
      es: "Registrando tu aceptación. Espera un momento.",
      "pt-BR": "Registrando seu aceite. Aguarde."
    },
    "Acceptance recorded. Continuing to checkout.": {
      es: "Aceptación registrada. Continuando al pago.",
      "pt-BR": "Aceite registrado. Continuando para o checkout."
    },
    "Could not reset acceptance. Please reload before continuing.": {
      es: "No se pudo restablecer la aceptación. Recarga la página antes de continuar.",
      "pt-BR": "Não foi possível limpar a referência do aceite. Recarregue a página antes de continuar."
    },
    "Checkout was stopped. Check your cart and details, then accept the policy again.": {
      es: "El proceso de pago se detuvo. Revisa el carrito y tus datos y acepta la política de nuevo.",
      "pt-BR": "A continuação foi interrompida. Confira o carrinho e seus dados e aceite a política novamente."
    },
    "Your cart changed. Please accept the policy again.": {
      es: "Tu carrito cambió. Acepta la política de nuevo.",
      "pt-BR": "Seu carrinho mudou. Aceite a política novamente."
    },
    "Your details changed. A new record is required.": {
      es: "Tus datos cambiaron. Es necesario un nuevo registro.",
      "pt-BR": "Seus dados mudaram. É necessário um novo registro."
    },
    "Acceptance selected. Enter your details to continue.": {
      es: "Aceptación seleccionada. Introduce tus datos para continuar.",
      "pt-BR": "Aceite selecionado. Preencha seus dados para continuar."
    },
    "Acceptance unchecked. A new acceptance is required.": {
      es: "Aceptación desmarcada. Es necesaria una nueva aceptación.",
      "pt-BR": "Aceite desmarcado. É necessário aceitar novamente."
    },
    "Please confirm your acceptance again.": {
      es: "Confirma tu aceptación de nuevo.",
      "pt-BR": "Confirme seu aceite novamente."
    }
  };
  const CHECKBOX = 'input[data-tncbox="gmtncBox"]';
  let busy = false;
  let revision = 0;
  let writes = Promise.resolve();
  let resetFailed = false;
  let pendingClear = null;
  let timingStart = null;
  let timingRows = [];

  // Diagnostics contain only durations and stage labels, never customer data.
  async function timed(stage, operation) {
    const started = performance.now();
    let outcome = "ok";
    try { return await operation(); }
    catch (error) { outcome = "erro"; throw error; }
    finally {
      if (timingStart !== null) timingRows.push({
        etapa: stage, ms: Math.round(performance.now() - started), resultado: outcome
      });
    }
  }
  function reportPerformance(outcome) {
    if (timingStart === null) return;
    timingRows.push({
      etapa: "Total ate redirecionar (nao inclui carregar checkout)",
      ms: Math.round(performance.now() - timingStart), resultado: outcome
    });
    timingStart = null;
    console.info("[Aceite: desempenho] Somente tempos, sem dados pessoais.");
    console.table(timingRows);
  }
  window.AlcoholConsentPerformance = Object.freeze({
    print() { console.table(timingRows.map(row => ({ ...row }))); }
  });

  let activeConsentContainer = null;
  function selectConsentContainer(target) {
    if (!(target instanceof Element)) return;
    const lateral = target.closest("cart-drawer");
    const full = target.closest("#main-cart-footer, form#cart, cart-items");
    const next = lateral || (full ? document.getElementById("main-cart-footer") : null);
    if (!next || next === activeConsentContainer) return;
    const previous = drawer();
    activeConsentContainer = next;
    if (previous && previous !== next) {
      // Never mix names, checkboxes, or security widgets between cart layouts.
      invalidate("Please confirm your acceptance again.");
      disposeEarly("Active cart layout changed");
    }
    scheduleEarly();
  }
  function drawer() {
    if (activeConsentContainer?.isConnected) return activeConsentContainer;
    const rootPath = new URL(ROOT, location.origin).pathname;
    if (location.pathname.replace(/\/$/, "") === `${rootPath}cart`) {
      return document.getElementById("main-cart-footer");
    }
    return document.querySelector("cart-drawer");
  }

  function status(message) {
    const container = drawer();
    if (!container) return;
    const translated = MESSAGES[message]?.[LANGUAGE] || message;
    const element = container.querySelector(
      "#AlcoholConsentStatus, #AlcoholConsentPageStatus"
    );
    if (element) element.textContent = translated;

    // Also show feedback beside the visible checkout control. The existing
    // field status can be clipped by the drawer's scrollable layout.
    const button = container.querySelector(
      "#CartDrawer-Checkout, #checkout"
    );
    if (!button?.parentElement) return;
    let feedback = container.querySelector('[data-alcohol-consent-feedback]');
    if (!feedback || feedback.parentElement !== button.parentElement) {
      feedback?.remove();
      feedback = document.createElement("p");
      feedback.setAttribute("data-alcohol-consent-feedback", "");
      feedback.setAttribute("role", "status");
      feedback.setAttribute("aria-live", "polite");
      feedback.setAttribute("aria-atomic", "true");
      button.parentElement.insertBefore(feedback, button);
    }
    feedback.style.cssText = "display:block!important;visibility:visible!important;opacity:1!important;width:100%;flex:0 0 100%;margin:8px 0;white-space:normal;overflow-wrap:anywhere;font-size:14px;line-height:1.4;";
    feedback.textContent = translated;
    const validationMessages = [
      "Please accept the alcoholic beverages shipping policy.",
      "Please enter your full name.",
      "Please enter a valid email address.",
      "Checkout was stopped. Check your cart and details, then accept the policy again.",
      "Could not reset acceptance. Please reload before continuing."
    ];
    if (validationMessages.includes(message)) {
      feedback.style.color = "#b3261e";
      requestAnimationFrame(() => {
        if (feedback.isConnected) feedback.scrollIntoView({ block: "nearest" });
      });
    }
  }

  async function request(url, options = {}) {
    const stage = url === API_URL ? "Registrar aceite no servidor"
      : url.endsWith("cart/update.js") ? "Atualizar referencias do carrinho"
      : "Consultar carrinho";
    return timed(stage, async () => {
      const response = await fetch(url, {
        ...options,
        cache: "no-store",
        signal: AbortSignal.timeout(15000)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);
      return data;
    });
  }

  const TURNSTILE_SITE_KEY = "0x4AAAAAAFQwBq_XAu3ukbmz";
  let turnstileLoader;

  function loadTurnstile() {
    if (window.turnstile?.render) return Promise.resolve();
    if (turnstileLoader) return turnstileLoader;
    turnstileLoader = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      const timeout = setTimeout(() => reject(new Error("Turnstile loading timed out")), 20000);
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.onload = () => {
        clearTimeout(timeout);
        if (window.turnstile?.render) resolve();
        else reject(new Error("Turnstile unavailable"));
      };
      script.onerror = () => {
        clearTimeout(timeout);
        reject(new Error("Turnstile loading failed"));
      };
      document.head.appendChild(script);
    }).catch(error => {
      turnstileLoader = null;
      throw error;
    });
    return turnstileLoader;
  }

  // Early challenge verifies the browser only. It never records policy consent.
  // Tokens stay in memory and are reserved once for a single server request.
  const preloadInfo = { estado: "nao iniciado", ms: 0 };
  let earlyState = null;
  let earlyScheduled = false;
  let earlyRetryAfter = 0;
  const LOCAL_TOKEN_MAX_AGE = 120000;

  function visibleFields(element) {
    if (!element?.isConnected || element.closest("[hidden]")) return false;
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== "none" && style.visibility === "visible" &&
      rect.width > 0 && rect.height > 0 && rect.bottom > 0 &&
      rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth;
  }

  function disposeEarly(reason = "Verification reset") {
    const state = earlyState;
    if (!state) return;
    earlyState = null;
    state.token = "";
    clearTimeout(state.timer);
    clearTimeout(state.expiryTimer);
    clearInterval(state.watcher);
    if (!state.settled) {
      state.settled = true;
      state.reject(new Error(reason));
    }
    // Callback may be executing; defer removal until it finishes.
    setTimeout(() => {
      try {
        if (state.widgetId !== undefined) window.turnstile?.remove(state.widgetId);
      } catch (_) {}
      state.host?.remove();
    }, 0);
  }

  function startEarly(fields) {
    if (earlyState && earlyState.fields === fields &&
        (earlyState.phase === "pending" || earlyState.phase === "ready")) {
      return earlyState;
    }
    disposeEarly();
    const state = {
      fields, phase: "pending", token: "", readyAt: 0, settled: false,
      started: performance.now(), ms: 0, widgetId: undefined, host: null,
      timer: null, expiryTimer: null, watcher: null
    };
    state.promise = new Promise((resolve, reject) => {
      state.resolve = resolve;
      state.reject = reject;
    });
    // Anticipatory failure has no waiting caller, so handle it locally.
    state.promise.catch(() => {});
    earlyState = state;
    function fail(reason) {
      if (earlyState !== state) return;
      earlyRetryAfter = Date.now() + 15000;
      disposeEarly(reason);
    }
    state.timer = setTimeout(() => fail("Security verification timed out"), 120000);
    state.watcher = setInterval(() => {
      if (earlyState !== state) return;
      if (!fields.isConnected || (state.host && !state.host.isConnected)) {
        fail("Acceptance fields replaced");
      }
    }, 200);
    const loadStarted = performance.now();
    preloadInfo.estado = "carregando";
    loadTurnstile().then(() => {
      preloadInfo.estado = "pronto";
      preloadInfo.ms = Math.round(performance.now() - loadStarted);
      if (earlyState !== state || !fields.isConnected) return;
      const host = document.createElement("div");
      host.style.margin = "12px 0";
      state.host = host;
      fields.appendChild(host);
      state.widgetId = window.turnstile.render(host, {
        sitekey: TURNSTILE_SITE_KEY,
        action: "alcohol_consent",
        size: "flexible",
        language: LANGUAGE === "pt-BR" ? "pt-br" : LANGUAGE,
        callback: token => {
          if (earlyState !== state || state.settled) return;
          if (typeof token !== "string" || !token) {
            fail("Empty verification token");
            return;
          }
          state.settled = true;
          state.phase = "ready";
          state.token = token;
          state.readyAt = Date.now();
          state.ms = Math.round(performance.now() - state.started);
          clearTimeout(state.timer);
          state.expiryTimer = setTimeout(() => {
            if (earlyState !== state) return;
            disposeEarly("Local token freshness limit reached");
            scheduleEarly();
          }, LOCAL_TOKEN_MAX_AGE);
          state.resolve();
        },
        "error-callback": () => fail("Security verification failed"),
        "expired-callback": () => fail("Security verification expired"),
        "timeout-callback": () => fail("Security challenge timed out")
      });
    }).catch(() => {
      preloadInfo.estado = "falhou";
      fail("Security verification could not start");
    });
    return state;
  }

  function checkEarly() {
    earlyScheduled = false;
    if (busy || Date.now() < earlyRetryAfter) return;
    const fields = drawer()?.querySelector(
      "#AlcoholConsentFields, #AlcoholConsentPageFields"
    );
    if (earlyState && (earlyState.fields !== fields || !visibleFields(fields))) {
      disposeEarly("Alcohol fields are no longer visible");
    }
    if (visibleFields(fields)) startEarly(fields);
  }
  function scheduleEarly() {
    if (earlyScheduled) return;
    earlyScheduled = true;
    requestAnimationFrame(checkEarly);
  }
  const earlyObserver = new MutationObserver(scheduleEarly);
  earlyObserver.observe(document.documentElement, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ["class", "style", "hidden", "open"]
  });
  document.addEventListener("focusin", event => {
    selectConsentContainer(event.target);
  }, true);
  document.addEventListener("transitionend", scheduleEarly, true);
  document.addEventListener("focusin", scheduleEarly, true);
  window.addEventListener("scroll", scheduleEarly, { passive: true });
  window.addEventListener("resize", scheduleEarly, { passive: true });
  scheduleEarly();

  async function getTurnstileToken(fields, startRevision, original) {
    assertUnchanged(startRevision, original);
    if (earlyState?.phase === "ready" &&
        Date.now() - earlyState.readyAt >= LOCAL_TOKEN_MAX_AGE) {
      disposeEarly("Stale verification token");
    }
    const state = startEarly(fields);
    const watcher = setInterval(() => {
      try { assertUnchanged(startRevision, original); }
      catch (_) {
        if (earlyState === state) disposeEarly("Cart or acceptance changed");
      }
    }, 100);
    try {
      await timed("Esperar verificacao restante apos clique", () => state.promise);
      assertUnchanged(startRevision, original);
      if (earlyState !== state || state.phase !== "ready" || !state.token ||
          Date.now() - state.readyAt >= LOCAL_TOKEN_MAX_AGE) {
        throw new Error("Verification token no longer usable");
      }
      if (timingStart !== null) timingRows.push({
        etapa: "Duracao completa da verificacao (nao somar ao total)",
        ms: state.ms, resultado: "ok"
      });
      // Reserve and erase locally before sending. Any retry needs a new token.
      const token = state.token;
      disposeEarly("Token reserved for one submission");
      return token;
    } finally {
      clearInterval(watcher);
    }
  }

  function readCart() { return request(`${ROOT}cart.js`); }

  function fingerprint(cart) {
    return JSON.stringify({
      token: cart.token,
      items: cart.items.map(item => ({
        key: item.key,
        quantity: item.quantity,
        properties: item.properties,
        selling_plan: item.selling_plan_allocation,
        price: item.final_line_price
      }))
    });
  }

  function enqueue(operation) {
    const result = writes.then(operation);
    writes = result.catch(() => {});
    return result;
  }

  async function updateAttributes(attributes) {
    const cart = await request(`${ROOT}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ attributes })
    });
    for (const [key, value] of Object.entries(attributes)) {
      if ((cart.attributes?.[key] || "") !== value) {
        throw new Error("Cart attribute verification failed");
      }
    }
    return cart;
  }

  function clearReference() {
    // Multiple invalidations share an in-flight clear. Revision still advances
    // synchronously for every change; no debounce or delayed invalidation.
    if (pendingClear) return pendingClear;
    pendingClear = enqueue(async () => {
      try {
        const cart = await updateAttributes({
          alcohol_consent_id: "",
          alcohol_terms_version: "",
          alcohol_terms_language: "",
          alcohol_terms_hash: ""
        });
        resetFailed = false;
        return cart;
      } catch (error) {
        resetFailed = true;
        throw error;
      }
    }).finally(() => { pendingClear = null; });
    return pendingClear;
  }

  function invalidate(message, uncheck = false) {
    revision += 1;
    // Browser challenges contain no name/email or policy acceptance. During
    // ordinary typing, an unfinished challenge can finish in the background.
    // Discard any ready token when details change; cart/checkbox resets and
    // changes during checkout cancel even an unfinished challenge.
    if (busy || uncheck ||
        message === "Acceptance unchecked. A new acceptance is required." ||
        (message === "Your details changed. A new record is required." &&
          earlyState?.phase === "ready")) {
      disposeEarly("Acceptance invalidated");
    }
    scheduleEarly();
    if (uncheck) {
      const checkbox = drawer()?.querySelector(CHECKBOX);
      if (checkbox) checkbox.checked = false;
    }
    status(message);
    clearReference().catch(error => {
      console.error("[Alcohol consent reset]", error);
      status("Could not reset acceptance. Please reload before continuing.");
    });
  }

  function values() {
    const container = drawer();
    const nameInput = container?.querySelector(
      "#AlcoholConsentName, #AlcoholConsentPageName"
    );
    const emailInput = container?.querySelector(
      "#AlcoholConsentEmail, #AlcoholConsentPageEmail"
    );
    return {
      fields: container?.querySelector(
        "#AlcoholConsentFields, #AlcoholConsentPageFields"
      ),
      checkbox: container?.querySelector(CHECKBOX),
      nameInput,
      emailInput,
      name: nameInput?.value.trim() || "",
      email: emailInput?.value.trim().toLowerCase() || ""
    };
  }

  function assertUnchanged(startRevision, original) {
    const current = values();
    if (
      revision !== startRevision ||
      !current.fields || !current.checkbox?.checked ||
      !window.AlcoholConsentPolicyUI?.ensure(drawer(), LANGUAGE) ||
      current.name !== original.name || current.email !== original.email
    ) {
      throw new Error("Acceptance or cart changed during submission");
    }
  }

  async function checkout(event) {
    const click = event.type === "click" &&
      event.target instanceof Element &&
      event.target.closest("#CartDrawer-Checkout, #main-cart-footer #checkout");
    const submit = event.type === "submit" &&
      event.target instanceof HTMLFormElement &&
      ["CartDrawer-Form", "cart"].includes(event.target.id);
    if (!click && !submit) return;
    selectConsentContainer(event.target);
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;

    busy = true;
    timingRows = [{
      etapa: "Pre-carga (fora do total apos clique)",
      ms: preloadInfo.ms, resultado: preloadInfo.estado
    }, {
      etapa: "Verificacao antecipada no momento do clique",
      ms: 0, resultado: earlyState?.phase || "nao iniciada"
    }];
    timingStart = performance.now();
    const startRevision = revision;
    let alcoholFlow = false;
    try {
      await timed("Esperar operacoes anteriores", () => writes);
      if (resetFailed) throw new Error("Previous reset failed");
      const cartBefore = await readCart();
      if (revision !== startRevision) throw new Error("Cart changed while checking");
      // Known localized values of the merchant's alcohol-only product type.
      const needsAcceptance = cartBefore.items.some(item =>
        ["Drink", "Bebida", "Beber"].includes(item.product_type)
      );

      if (!needsAcceptance) {
        disposeEarly("No alcohol in cart");
        await clearReference();
        const latest = await readCart();
        if (revision !== startRevision || fingerprint(latest) !== fingerprint(cartBefore)) {
          throw new Error("Cart changed before checkout");
        }
        reportPerformance("sem bebidas");
        window.location.assign(`${ROOT}checkout`);
        return;
      }

      alcoholFlow = true;
      const original = values();
      if (!original.fields) throw new Error("Alcohol acceptance fields are missing");
      if (!window.AlcoholConsentPolicyUI?.ensure(drawer(), LANGUAGE)) {
        throw new Error("Translated policy label or link is unavailable");
      }
      if (!original.checkbox?.checked) {
        status("Please accept the alcoholic beverages shipping policy.");
        original.checkbox?.focus();
        return;
      }
      if (!original.name || original.name.length > 200) {
        status("Please enter your full name.");
        original.nameInput?.focus();
        return;
      }
      if (!original.email || original.email.length > 254 || !original.emailInput?.checkValidity()) {
        status("Please enter a valid email address.");
        original.emailInput?.focus();
        return;
      }

      await clearReference();
      assertUnchanged(startRevision, original);
      status("Please complete the security verification if prompted.");
      const turnstileToken = await getTurnstileToken(original.fields, startRevision, original);
      assertUnchanged(startRevision, original);
      status("Recording your acceptance. Please wait.");
      const consent = await request(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: original.name,
          email: original.email,
          consent: true,
          turnstile_token: turnstileToken,
          terms_language: LANGUAGE,
          terms_version: TERMS_VERSION,
          terms_hash: POLICY_HASHES[LANGUAGE],
          page_url: location.origin + location.pathname
        })
      });
      if (consent.success !== true || typeof consent.id !== "string" || !consent.id ||
          consent.terms_version !== TERMS_VERSION || consent.terms_language !== LANGUAGE ||
          consent.terms_hash !== POLICY_HASHES[LANGUAGE]) {
        throw new Error("Invalid API response");
      }
      assertUnchanged(startRevision, original);
      const cartAfter = await readCart();
      assertUnchanged(startRevision, original);
      if (fingerprint(cartAfter) !== fingerprint(cartBefore)) {
        throw new Error("Cart contents changed");
      }

      await enqueue(async () => {
        assertUnchanged(startRevision, original);
        const updated = await updateAttributes({
          alcohol_consent_id: consent.id,
          alcohol_terms_version: TERMS_VERSION,
          alcohol_terms_language: LANGUAGE,
          alcohol_terms_hash: POLICY_HASHES[LANGUAGE]
        });
        assertUnchanged(startRevision, original);
        if (fingerprint(updated) !== fingerprint(cartBefore)) {
          throw new Error("Cart changed while saving reference");
        }
      });
      await writes;
      const finalCart = await readCart();
      assertUnchanged(startRevision, original);
      if (fingerprint(finalCart) !== fingerprint(cartBefore) ||
          finalCart.attributes?.alcohol_consent_id !== consent.id) {
        throw new Error("Final cart verification failed");
      }
      status("Acceptance recorded. Continuing to checkout.");
      reportPerformance("aceite confirmado");
      window.location.assign(`${ROOT}checkout`);
    } catch (error) {
      disposeEarly("Checkout attempt failed");
      console.error("[Alcohol consent]", error);
      try {
        await clearReference();
        status("Checkout was stopped. Check your cart and details, then accept the policy again.");
      } catch (resetError) {
        console.error("[Alcohol consent cleanup]", resetError);
        status("Could not reset acceptance. Please reload before continuing.");
      }
      if (alcoholFlow) {
        const checkbox = drawer()?.querySelector(CHECKBOX);
        if (checkbox) checkbox.checked = false;
      }
    } finally {
      reportPerformance("permaneceu no carrinho");
      busy = false;
      scheduleEarly();
    }
  }

  document.addEventListener("click", event => {
    const target = event.target;
    selectConsentContainer(target);
    if (!(target instanceof Element)) return;
    if (target.closest("cart-drawer, cart-items") &&
        target.closest('button[name="plus"], button[name="minus"], cart-remove-button')) {
      invalidate("Your cart changed. Please accept the policy again.", true);
    }
  }, true);

  document.addEventListener("input", event => {
    const target = event.target;
    selectConsentContainer(target);
    if (!(target instanceof Element)) return;
    if (target.matches(
      "#AlcoholConsentName, #AlcoholConsentEmail, #AlcoholConsentPageName, #AlcoholConsentPageEmail"
    )) {
      invalidate("Your details changed. A new record is required.");
    } else if (target.closest("cart-drawer, cart-items") &&
               target.matches('input[name="updates[]"]')) {
      invalidate("Your cart changed. Please accept the policy again.", true);
    }
  }, true);

  document.addEventListener("change", event => {
    const target = event.target;
    selectConsentContainer(target);
    if (target instanceof HTMLInputElement &&
        target.closest("cart-drawer, #main-cart-footer, form#cart") &&
        target.matches(CHECKBOX)) {
      invalidate(target.checked
        ? "Acceptance selected. Enter your details to continue."
        : "Acceptance unchecked. A new acceptance is required.");
    }
  }, true);

  document.addEventListener("click", checkout, true);
  document.addEventListener("submit", checkout, true);

  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      invalidate("Your cart changed. Please accept the policy again.", true);
    });
  } else {
    resetFailed = true;
    console.error("[Alcohol consent] Cart subscription unavailable.");
  }

  window.addEventListener("pageshow", event => {
    if (event.persisted) {
      invalidate("Please confirm your acceptance again.", true);
    }
  });
})();











